import { useMemo } from "react";
import { useUser } from "../context/UserConext";
import { CUPOS_SUBNAV, type MenuItem } from "../types/menu.types";
import {
  Home as HomeIcon,
  People as UsersIcon,
  Terminal as TerminalIcon,
  ShoppingCart,
} from "@mui/icons-material";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import InventoryIcon from "@mui/icons-material/Inventory";
import BusinessIcon from "@mui/icons-material/Business";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import ReportIcon from "@mui/icons-material/Report";
import PieChartOutlinedIcon from "@mui/icons-material/PieChartOutlined";

const useMenuHook = () => {
  const { user } = useUser();

  const menu = useMemo((): MenuItem[] => {
    /** Siempre muestar pantalla de inicio */
    const localMenu: MenuItem[] = [
      { text: "Inicio", icon: <HomeIcon />, path: "/home" },
    ];

    for (const permission of user?.user?.permission) {
      if (permission === "CRUD_COMPANIES" || permission === "VIEW_ADMIN") {
        localMenu.push({
          text: "Sociedades",
          icon: <BusinessIcon />,
          path: "/societies",
        });
      }
      if (permission === "CRUD_USERS" || permission === "VIEW_ADMIN") {
        localMenu.push({
          text: "Usuarios",
          icon: <UsersIcon />,
          path: "/users",
        });
      }
      if (permission === "VIEW_LOGS" || permission === "VIEW_ADMIN") {
        localMenu.push({
          text: "Logs",
          icon: <TerminalIcon />,
          path: "/logs",
        });
      }
      if (permission === "VIEW_CLIENTS" || permission === "VIEW_ADMIN") {
        localMenu.push({
          text: "Clientes",
          icon: <PersonAddIcon />,
          path: "/clients",
        });
      }
      if (permission === "VIEW_PRODUCTS" || permission === "VIEW_ADMIN") {
        localMenu.push({
          text: "Productos",
          icon: <InventoryIcon />,
          path: "/products",
        });
      }
      if (permission === "CRUD_STOCK" || permission === "VIEW_ADMIN") {
        localMenu.push({
          text: "Stock",
          icon: <WarehouseIcon />,
          path: "/stock",
        });
      }
      if (permission === "CLIENT") {
        localMenu.push({
          text: "Pedidos",
          icon: <ShoppingCart />,
          path: "/orders",
        });
      }
      if (permission === "VIEW_REPORTS" || permission === "VIEW_ADMIN") {
        localMenu.push({
          text: "Reportes",
          icon: <ReportIcon />,
          path: "/reports",
        });
      }
      if (permission === "CRUD_CLASSIFICATION" || permission === "VIEW_ADMIN") {
        localMenu.push({
          text: "Cupos",
          icon: <PieChartOutlinedIcon />,
          path: "/cupos/producto",
          subNav: CUPOS_SUBNAV,
        });
      }
    }

    return localMenu;
  }, [user]);

  return { menu };
};

export default useMenuHook;
